import { fetcher } from '@commenda/utils';

const baseURL = 'marketplace/vendor/service';

export interface IPricingVariant {
  country: string;
  price: number;
  sla: {
    minDay?: string;
    maxDay?: string;
  };
  priceDisplaySuffix?: string; // for referrals
  discountCode?: string; // for referrals
}

export interface CreateFirmProvidedServiceProps {
  id?: string; // Optional for updating
  productId: string;
  caFirmId: string;
  description: string;
  steps: string[]; // tentativeProcess
  firmServiceDetails: string[]; // inclusions
  meetingLink?: string; // for referrals
  redirectionLinkForPurchase?: string; // for referrals
  pricingVariants?: IPricingVariant[]; // for non-referrals
  jurisdictions?: string[];
}

export async function createFirmProvidedService({
  id,
  productId,
  caFirmId,
  description,
  steps,
  firmServiceDetails,
  meetingLink,
  redirectionLinkForPurchase,
  pricingVariants,
  jurisdictions,
}: CreateFirmProvidedServiceProps) {
  try {
    const res = await fetcher(
      id ? `${baseURL}/${id}` : baseURL,
      {
        method: 'POST',
        body: {
          productId,
          caFirmId,
          description,
          steps,
          firmServiceDetails,
          meetingLink,
          redirectionLinkForPurchase,
          pricingVariants,
          jurisdictions,
        },
      },
      undefined
    );

    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
}
